import { useEffect, useState } from "react";
import CommonModal from "../shared/modalLayout/CommonModal";
import { useGetVaAudiologistBundlesQuery } from "../../app/vaApi/vaApi";
import { getAudiologistBundleDetailRows } from "../../helpers/vaInvoiceUtils";
import "../../styles/selectBundleModal.css";

function BundleDetailValue({ items }) {
  if (items.length <= 1) {
    return <span>{items[0] || ""}</span>;
  }

  return (
    <span className="select-bundle-card__value-list">
      {items.map((item, index) => (
        <span key={`${item}-${index}`} className="select-bundle-card__value-line">
          <span className="select-bundle-card__value-index">{index + 1}.</span>
          <span>{item}</span>
        </span>
      ))}
    </span>
  );
}

export default function SelectBundleModal({
  show,
  onClose,
  onBack,
  onSelect,
  productId,
  skuLabel,
}) {
  const {
    data: bundles = [],
    isLoading,
    isError,
    refetch,
  } = useGetVaAudiologistBundlesQuery(productId, {
    skip: !show || !productId,
  });

  const [selectedCode, setSelectedCode] = useState("");

  useEffect(() => {
    if (!show) return;
    if (bundles.length > 0) {
      setSelectedCode((prev) =>
        bundles.some((b) => b.code === prev) ? prev : bundles[0].code
      );
    } else {
      setSelectedCode("");
    }
  }, [show, bundles]);

  const handleSelect = (bundle) => {
    setSelectedCode(bundle.code);
    onSelect(bundle.code, bundle);
  };

  return (
    <CommonModal
      show={show}
      setShow={(open) => {
        if (!open) onClose();
      }}
      title="Select the bundle"
      centered
      className="select-bundle-modal modal-md"
      onHide={onClose}
      onBack={onBack}
      closeOnBackdrop={false}
    >
      {skuLabel ? (
        <p className="text-muted small mb-3 text-center">
          Bundles for <strong>{skuLabel}</strong>
        </p>
      ) : null}

      {!productId && (
        <p className="text-center text-muted mb-0 py-4">
          Select a SKU first to see available bundles.
        </p>
      )}

      {productId && isLoading && (
        <p className="text-center text-muted mb-0 py-4">Loading bundles…</p>
      )}

      {productId && !isLoading && isError && (
        <div className="text-center py-4">
          <p className="text-danger mb-2">Could not load bundles from Shopify.</p>
          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            onClick={refetch}
          >
            Retry
          </button>
        </div>
      )}

      {productId && !isLoading && !isError && bundles.length === 0 && (
        <p className="text-center text-muted mb-0 py-4">
          No AUD bundles found for this product. Check Shopify AUD bundle
          products and AUDIOLOGIST_BUNDLE_SKU_MAP.
        </p>
      )}

      {productId && !isLoading && !isError && bundles.length > 0 && (
        <div
          className={`select-bundle-grid${
            bundles.length === 1 ? " select-bundle-grid--single" : ""
          }`}
        >
          {bundles.map((bundle) => {
            const details = getAudiologistBundleDetailRows(bundle);
            const isSolo = bundles.length === 1;

            return (
              <button
                key={bundle.code}
                type="button"
                className={`select-bundle-card${
                  selectedCode === bundle.code
                    ? " select-bundle-card--selected"
                    : ""
                }${isSolo ? " select-bundle-card--solo" : ""}`}
                onClick={() => handleSelect(bundle)}
              >
                {isSolo ? (
                  <span className="select-bundle-card__eyebrow">
                    Available bundle
                  </span>
                ) : null}
                <div className="select-bundle-card__code">{bundle.code}</div>
                {bundle.label &&
                String(bundle.label).trim().toUpperCase() !==
                  String(bundle.code).trim().toUpperCase() ? (
                  <div className="select-bundle-card__label">{bundle.label}</div>
                ) : null}
                {details.length > 0 ? (
                  <ul className="bundle-breakdown select-bundle-card__details">
                    {details.map((item) => (
                      <li
                        key={item.label}
                        className={
                          item.items.length > 1
                            ? "select-bundle-card__detail--stacked"
                            : undefined
                        }
                      >
                        <span>{item.label}</span>
                        <BundleDetailValue items={item.items} />
                      </li>
                    ))}
                  </ul>
                ) : null}
                {isSolo ? (
                  <span className="select-bundle-card__cta">
                    Continue with this bundle
                  </span>
                ) : null}
              </button>
            );
          })}
        </div>
      )}
    </CommonModal>
  );
}
